import _ from 'underscore';

let schemaI18nCampaign = null;
let i18n = null;
export function initialize(options) {
  ({
    schemaI18nCampaign,
    i18n,
  } = options);
}

export function lambdaConvertForAvailableInsightTypeIds() {
  return (values) => {
    let url = '';

    _.each(values, (value, index) => {
      if (index > 0) {
        url += ' or ';
      }
      url += `d eq ${value}`;
    });
    url = `AvailableInsightTypeIds/any(d:${url})`;
    return url;
  };
}

export const baseEntitySchemaForAvailableInsightTypeIds = {
  property: 'AvailableInsightTypeIds',
  type: 'string',
  filterable: true,
  enumType: 'FluctuationType',
  enum: [
    "Enum.FluctuationType'Click'",
    "Enum.FluctuationType'Impression'",
    "Enum.FluctuationType'Spend'",
    "Enum.FluctuationType'Conversion'",
  ],
  enumValueMap: {
    "Enum.FluctuationType'Click'": 'Click',
    "Enum.FluctuationType'Impression'": 'Impression',
    "Enum.FluctuationType'Spend'": 'Spend',
    "Enum.FluctuationType'Conversion'": 'Conversion',
  },
  chooseType: 'checkbox',
  operators: ['contains'],
};

export function updateEntitySchemaForAvailableInsightTypeIds(entitySchema) {
  const entitySchemaCopy = entitySchema;
  entitySchemaCopy.properties.AvailableInsightTypeIds = {
    ...baseEntitySchemaForAvailableInsightTypeIds,
    name: schemaI18nCampaign.property('Campaign', 'AvailableInsightTypeIds'),
    title: schemaI18nCampaign.property('Campaign', 'AvailableInsightTypeIds'),
    localized: {
      "Enum.FluctuationType'Click'": schemaI18nCampaign.enum('FluctuationType', 'Click'),
      "Enum.FluctuationType'Impression'": schemaI18nCampaign.enum('FluctuationType', 'Impression'),
      "Enum.FluctuationType'Spend'": schemaI18nCampaign.enum('FluctuationType', 'Spend'),
      "Enum.FluctuationType'Conversion'": i18n.getString(_TL_('Conversions')),
    },
  };
  return entitySchemaCopy;
}

export function updateOdataOptionsForAvailableInsightTypeIds(options) {
  if (options) {
    const optionsCopy = options;

    _.extendOwn(optionsCopy.custom, {
      AvailableInsightTypeIds: {
        contains: lambdaConvertForAvailableInsightTypeIds(),
      },
    });
    return optionsCopy;
  }
  return options;
}
